/**
 * Lifecycle of an organization invitation. Serialized as PascalCase strings.
 */
export enum OrganizationInvitationStatus {
  Pending = "Pending",
  Accepted = "Accepted",
  Revoked = "Revoked",
  Expired = "Expired",
}
